export type RemoteQuestionImageUrl = `s3://${string}/${string}`; // uploaded to s3 bucket name / file name
export type LocalQuestionImageUrl = `local://${string}/${string}`; // uploaded to local file only, bucket name / file name

export type QuestionImageUrl = RemoteQuestionImageUrl | LocalQuestionImageUrl;

export function isRemoteQuestionImageUrl(
  questionImageUrl: QuestionImageUrl,
): questionImageUrl is RemoteQuestionImageUrl {
  return questionImageUrl.startsWith('s3://');
}

export function isLocalQuestionImageUrl(questionImageUrl: QuestionImageUrl): questionImageUrl is LocalQuestionImageUrl {
  return questionImageUrl.startsWith('local://');
}

export function getNameAndBucketNameFromRemoteQuestionImageUrl(questionImageUrl: RemoteQuestionImageUrl): {
  imageName: string;
  bucketName: string;
} {
  const urlWithoutPrefix = questionImageUrl.replace('s3://', '');
  const [bucketName, ...nameParts] = urlWithoutPrefix.split('/');
  const imageName = nameParts.join('/');
  return { imageName, bucketName };
}

export function getNameAndBucketNameFromLocalQuestionImageUrl(questionImageUrl: LocalQuestionImageUrl): {
  imageName: string;
  bucketName: string;
} {
  const urlWithoutPrefix = questionImageUrl.replace('local://', '');
  const [bucketName, ...nameParts] = urlWithoutPrefix.split('/');
  const imageName = nameParts.join('/');
  return { imageName, bucketName };
}

export interface ImageContent {
  url: QuestionImageUrl | null;
  original_url: QuestionImageUrl | null;
  code: string | null;
  generation_completed: boolean;
}

export interface QuestionImage {
  content: ImageContent;
  description?: string;
  title?: string;
  not_to_scale?: boolean;
  style?: Partial<CSSStyleDeclaration>;
  container_width?: string; // Width percentage for flex container layout (e.g., "50%", "75%", "100%")
}

export interface QuestionImageCacheEntry {
  file: File;
  remoteUrl: RemoteQuestionImageUrl | null;
}

export interface SerializedFileData {
  name: string;
  type: string;
  lastModified: number;
  size: number;
  base64Data: string;
}

export interface SerializedQuestionImageCacheEntry {
  file: SerializedFileData;
  remoteUrl: RemoteQuestionImageUrl | null;
}

export interface SerializedQuestionImageCache {
  [key: LocalQuestionImageUrl]: SerializedQuestionImageCacheEntry;
}
